import type { PublicHealerProfile } from "../../types";

interface HealerSlugSource {
  fullName?: string | null;
}

export function createReadableSlug(value: string | null | undefined, fallback: string): string {
  const slug = (value ?? "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || fallback;
}

export function getHealerProfileSlug(healer: HealerSlugSource): string {
  return createReadableSlug(healer.fullName, "healer");
}

export function getPublicHealerProfilePath(healer: Pick<PublicHealerProfile, "fullName">): string {
  return `/healers/${getHealerProfileSlug(healer)}`;
}
